export const ORDER_TRACKER_STATES = {
  CURRENT: 'in_progress',
  PAST: 'done',
  FUTURE: 'planned',
  OPTION: 'option',
};

export const PAYMENT_METHODS = {
  CARD: 'CARD',
  INSURANCE: 'INSURANCE',
};

export enum OrderPerson {
  ME = 'me',
  MY_PARTNER = 'my_partner',
  ALL = 'my_and_my_partner',
}

export enum Pregnant {
  YES = 'pregnant',
  No = 'not pregnant',
  UNKNOWN = 'unknown',
}

export enum Sex {
  MALE = 'male',
  FEMALE = 'female',
}

export enum isSameInsurancePlan {
  YES = 'yes',
  NO = 'no',
}

export const PREGNANT = ['Pregnant', 'Not pregnant', 'Unknown'];

export const ETHNICITY = [
  'Northern European',
  'Southern European',
  'French Canadian or Cajun',
  'Ashkenazi Jewish',
  'Finnish',
  'Mixed or Other Caucasian',
  'African or African American',
  'East Asian',
  'South Asian',
  'Southeast Asian',
  'Hispanic',
  'Middle Eastern',
  'Native American',
  'Pacific Islander',
  'Unknown / Not reported',
];

export const INSURANCE_COMPANY_NAMES = [
  'Aetna',
  'Blue Cross Blue Shield Federal Employee',
  'Anthem Blue Cross of California',
  'Blue Shield of California',
  'Cigna',
  'Harvard Pilgrim Health Plan',
  'Humana Health Plan',
  'Kaiser Northern California',
  'Medicaid CA',
  'Medicaid TX',
  'Neighborhood Health Partnership',
  'United Health Care',
];

export const TESTING_REASONS = [
  'Screening for genetic disease carrier status',
  'Consanguinity',
  'Egg or sperm donor',
  'Family history',
  'High risk ethnicity',
  'Other genetic carrier status',
  'Supervision, normal first pregnancy',
  'Supervision, other normal pregnancy',
];

export const SEX_ASSIGNED_AT_BIRTH = ['Male', 'Female'];

export enum ResultOrderStatus {
  RESULTS_READY = 'RESULTS_READY',
  RESULTS_MANAGED = 'RESULTS_MANAGED',
  MANAGEMENT_OFF = 'MANAGEMENT_OFF',
}
